import { getCategory } from '../../common/store/categories/categories-selectors';
import { type AppState } from '../../common/types';

export const getLastFeaturedPost = (state: AppState) => state.lastFeaturedPost;

export const getLastFeaturedPostCategory = (state: AppState) =>
  getLastFeaturedPost(state) && getCategory(state, getLastFeaturedPost(state)!.categoryIds![0]);
